module.exports = __webpack_public_path__ + "static/media/fr.a6a00f15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/languages/fr.svg
// module id = 1693
// module chunks = 0